<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">お客様情報・配送先</div>
    <div class="row m-0 justify-content-center" style="padding: 40px 0px; flex-wrap: nowrap;">
        <div class="border-color">
        </div>
        <div class="tab m-0" :class="{ 'tab-select': this.$store.state.shippingScreenType == 'User' }" @click="clickTab('User')">
          <svg class="icon" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
          <path id="Vector" d="M13 13.0003C10.698 13.0003 8.83338 11.1357 8.83338 8.83366C8.83338 6.53158 10.698 4.66699 13 4.66699C15.3021 4.66699 17.1667 6.53158 17.1667 8.83366C17.1667 11.1357 15.3021 13.0003 13 13.0003ZM13 15.0837C15.7813 15.0837 21.3334 16.4795 21.3334 19.2503L21.3334 21.3337L4.66671 21.3337L4.66671 19.2503C4.66671 16.4795 10.2188 15.0837 13 15.0837Z"/>
          </g>
          </svg>
          <span class="m-2">ユーザー情報</span>
        </div>
        <div class="tab m-0" style="border-left: 0px;" :class="{ 'tab-select': this.$store.state.shippingScreenType == 'List' ||
         this.$store.state.shippingScreenType == 'AddShipping' || this.$store.state.shippingScreenType == 'EditShipping'  }" @click="clickTab('List')">
          <svg class="icon" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
          <path id="evaCarFill2" d="M1.45995 11.9519L6.74934 7.6974L6.74934 4.79974C6.72118 4.21899 6.92446 3.65077 7.31461 3.21967C7.70475 2.78856 8.24993 2.52976 8.8306 2.5L21.9391 2.5C22.5157 2.5356 23.055 2.79693 23.4403 3.22739C23.8255 3.65784 24.0257 4.22275 23.9974 4.79974L23.9974 16.2984C24.008 16.755 23.8825 17.2045 23.6367 17.5895C23.391 17.9745 23.0362 18.2776 22.6175 18.4602C22.8293 18.9782 22.9118 19.5401 22.858 20.0971C22.8042 20.6542 22.6156 21.1898 22.3086 21.6578C22.0016 22.1257 21.5853 22.5119 21.0957 22.7831C20.6061 23.0543 20.0578 23.2022 19.4983 23.2142C18.9387 23.2262 18.3847 23.1019 17.8839 22.8519C17.3831 22.602 16.9507 22.234 16.6239 21.7796C16.2971 21.3252 16.0858 20.7982 16.0081 20.2439C15.9305 19.6897 15.9889 19.1248 16.1783 18.5982L8.8651 18.5982C9.05421 19.1192 9.11498 19.6781 9.04226 20.2276C8.96954 20.7771 8.76547 21.301 8.44733 21.755C8.12919 22.2089 7.70636 22.5794 7.21463 22.8353C6.72291 23.0911 6.17677 23.2247 5.62247 23.2247C5.06817 23.2247 4.52204 23.0911 4.03031 22.8353C3.53858 22.5794 3.11575 22.2089 2.79761 21.755C2.47947 21.301 2.2754 20.7771 2.20268 20.2276C2.12996 19.6781 2.19073 19.1192 2.37984 18.5982L2.14987 18.5982C1.84491 18.5982 1.55243 18.477 1.33679 18.2614C1.12115 18.0457 1 17.7533 1 17.4483L1 12.8488C1.00352 12.6742 1.04677 12.5027 1.12646 12.3473C1.20616 12.1919 1.3202 12.0567 1.45995 11.9519ZM3.29974 13.4008L3.29974 16.2984L6.74934 16.2984L6.74934 10.6411L3.29974 13.4008ZM18.248 19.748C18.248 19.9754 18.3155 20.1978 18.4418 20.3869C18.5682 20.5759 18.7477 20.7233 18.9579 20.8104C19.168 20.8974 19.3992 20.9202 19.6222 20.8758C19.8453 20.8314 20.0502 20.7219 20.211 20.5611C20.3718 20.4003 20.4813 20.1954 20.5257 19.9723C20.57 19.7493 20.5473 19.5181 20.4602 19.308C20.3732 19.0979 20.2258 18.9183 20.0367 18.7919C19.8476 18.6656 19.6253 18.5982 19.3979 18.5982C19.0929 18.5982 18.8004 18.7193 18.5848 18.9349C18.3692 19.1506 18.248 19.4431 18.248 19.748ZM4.4496 19.748C4.4496 19.9754 4.51704 20.1978 4.64339 20.3869C4.76974 20.576 4.94933 20.7233 5.15944 20.8104C5.36955 20.8974 5.60075 20.9202 5.8238 20.8758C6.04685 20.8314 6.25174 20.7219 6.41255 20.5611C6.57336 20.4003 6.68288 20.1954 6.72725 19.9724C6.77161 19.7493 6.74884 19.5181 6.66181 19.308C6.57478 19.0979 6.4274 18.9183 6.23831 18.7919C6.04921 18.6656 5.82689 18.5982 5.59947 18.5982C5.29451 18.5982 5.00203 18.7193 4.78639 18.9349C4.57075 19.1506 4.4496 19.4431 4.4496 19.748Z"/>
          </g>
          </svg>
          <span class="m-2">配送情報</span>
        </div>
        <div class="tab m-0 text-nowrap" style="border-left: 0px;" :class="{ 'tab-select': this.$store.state.shippingScreenType == 'Mail' }" @click="clickTab('Mail')">
          <svg class="icon" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
          <path id="Vector" d="M4.16669 4.66699L20.8334 4.66699C21.9792 4.66699 22.9063 5.60449 22.9063 6.75033L22.9167 19.2503C22.9167 20.3962 21.9792 21.3337 20.8334 21.3337L4.16669 21.3337C3.02085 21.3337 2.08335 20.3962 2.08335 19.2503L2.08335 6.75033C2.08335 5.60449 3.02085 4.66699 4.16669 4.66699ZM4.16669 8.83366L12.5 14.042L20.8334 8.83366L20.8334 6.75033L12.5 11.9587L4.16669 6.75033L4.16669 8.83366Z"/>
          </g>
          </svg>
          <span class="m-2 ">メールアドレス</span>
        </div>
        <div class="tab m-0" style="border-left: 0px;" :class="{ 'tab-select': this.$store.state.shippingScreenType == 'Pass' }" @click="clickTab('Pass')">
          <svg class="icon" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
          <g id="Icon">
          <path id="Vector" d="M6.75004 8.83366L7.79171 8.83366L7.79171 6.75033C7.79171 3.87533 10.125 1.54199 13 1.54199C15.875 1.54199 18.2084 3.87533 18.2084 6.75033L18.2084 8.83366L19.25 8.83366C20.3959 8.83366 21.3334 9.77116 21.3334 10.917L21.3334 21.3337C21.3334 22.4795 20.3959 23.417 19.25 23.417L6.75004 23.417C5.60421 23.417 4.66671 22.4795 4.66671 21.3337L4.66671 10.917C4.66671 9.77116 5.60421 8.83366 6.75004 8.83366ZM13 18.2087C14.1459 18.2087 15.0834 17.2712 15.0834 16.1253C15.0834 14.9795 14.1459 14.042 13 14.042C11.8542 14.042 10.9167 14.9795 10.9167 16.1253C10.9167 17.2712 11.8542 18.2087 13 18.2087ZM9.77088 8.83366L16.2292 8.83366L16.2292 6.75033C16.2292 4.96908 14.7813 3.52116 13 3.52116C11.2188 3.52116 9.77088 4.96908 9.77088 6.75033L9.77088 8.83366Z"/>
          </g>
          </svg>
          <span class="m-2">パスワード</span>
        </div>
        <div class="border-color">
        </div>
    </div>

    <CenterViewShippingUser v-if="this.$store.state.shippingScreenType == 'User'"/>
    <CenterViewShippingList_Ap v-if="this.$store.state.shippingScreenType == 'List'"/>
    <CenterViewShippingMail v-if="this.$store.state.shippingScreenType == 'Mail'"/>
    <CenterViewShippingPassword v-if="this.$store.state.shippingScreenType == 'Pass'"/>
    <CenterViewShippingAdd_Ap v-if="this.$store.state.shippingScreenType == 'AddShipping'"/>
    <CenterViewShippingAdd_Ap v-if="this.$store.state.shippingScreenType == 'EditShipping'"/>
  </div>
</template>

<script>
import CenterViewShippingList_Ap from "@/components/acyrpro/shipping/CenterViewShippingList_Ap.vue";
import CenterViewShippingAdd_Ap from "@/components/acyrpro/shipping/CenterViewShippingAdd_Ap.vue";
import CenterViewShippingUser from "@/components/acyrpro/shipping/CenterViewShippingUser_Ap.vue";
import CenterViewShippingMail from "@/components/acyrpro/shipping/CenterViewShippingMail_Ap.vue";
import CenterViewShippingPassword from "@/components/acyrpro/shipping/CenterViewShippingPassword_Ap.vue";

export default {
  name: "CenterViewShipping_Ap",
  props: {},
  data: function () {
    return {
      destinationList: [],
      userInfo: null,
    };
  },
  computed: {},
  created: async function () {
    this.$store.commit("hideRightMenu");
  },
  components: {
    // CenterViewShippingFirst_Ap,
    CenterViewShippingList_Ap,
    CenterViewShippingAdd_Ap,
    // CenterViewShippingConfirm_Ap,
    CenterViewShippingUser,
    CenterViewShippingMail,
    CenterViewShippingPassword,
  },
  methods: {
    clickTab(name){
      this.$store.commit('setShippingScreenType', name)
    }
  },
};
</script>
<style scoped lang="scss">
.tab {
  width: 170px;
  height: 40px;
  fill: $primary-main-color;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
  padding: 5px;
  font-family: 'Noto Sans JP';
  font-weight: bold;
  border-radius: 0px;
}
.tab:hover{
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.tab-select {
  fill: $text-white-color;
  color: $text-white-color;
  background-color: $primary-main-color;
}
.border-color{
  width: 15%;
  border-bottom: 1px solid $border-main-color;
}
.icon{
  margin-top: -5px;
}
.shippingrow {
  width: 500px;
  margin: 0 auto;
}
</style>
